import { render, staticRenderFns } from "./Subject.vue?vue&type=template&id=dab18baa&scoped=true&lang=pug"
import script from "./Subject.vue?vue&type=script&lang=ts"
export * from "./Subject.vue?vue&type=script&lang=ts"
import style0 from "./Subject.vue?vue&type=style&index=0&id=dab18baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab18baa",
  null
  
)

export default component.exports